// Guard partagé pour le bouton "Retour" global du DashboardLayout.
// Une page peut enregistrer un handler custom (ex: modale "sécuriser le dossier").
// - Si le handler retourne `false`, la navigation par le bouton global est annulée.
// - Sinon, `navigate(-1)` s'exécute normalement.
let currentGuard = null;

export const setBackGuard = (fn) => { currentGuard = fn; };
export const clearBackGuard = () => { currentGuard = null; };
export const runBackGuard = () => (currentGuard ? currentGuard() : true);
